import { mapCollection } from '../../utils/collection.utils';
import { EvolutionReport } from '../evolution-report';

export class EvolutionReportBuilder {
  static fromJson(json) {
    return (json)
      ? new EvolutionReport(
        json.pollName,
        json.evolutionReportResults
      )
      : null;
  }

  static fromList(list) {
    return (Array.isArray(list)) ? mapCollection(EvolutionReportBuilder.fromJson, list) : [];
  }
}
